import { render, staticRenderFns } from "./Histories.vue?vue&type=template&id=29fe63f8"
import script from "./Histories.vue?vue&type=script&lang=ts"
export * from "./Histories.vue?vue&type=script&lang=ts"
import style0 from "./Histories.vue?vue&type=style&index=0&id=29fe63f8&prod&lang=scss&scpoed=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports